import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 44,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(24px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#ef4444",
                opacity: 1,
                border: 0,
            },
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 16,
        height: 16,
        boxShadow: "0 2px 4px 0 rgb(0 0 0 / 0.1)",
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "#ef4444",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
    },
}));

const UserToggleSwitch = ({ checked, onChange }) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                userSelect: "none",
                backgroundColor: "#F6F6F6",
                mr: 2,
                p: 1,
                borderRadius: "8px",
            }}
        >
            <Typography
                sx={{
                    fontSize: "0.775rem",
                    fontWeight: checked ? 500 : 600,
                    color: checked ? "#6b7280" : "#ef4444",
                }}
            >
                User
            </Typography>

            <CustomSwitch
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
            />

            <Typography
                sx={{
                    fontSize: "0.775rem",
                    fontWeight: checked ? 600 : 500,
                    color: checked ? "#ef4444" : "#6b7280",
                }}
            >
                Admin
            </Typography>
        </Box>
    );
};

export default UserToggleSwitch;
